import { createTraitsSelector } from '@atlassian/jira-traits/src/TraitsStore.tsx';

export const useLinkedTrelloWorkspaceTraitSelector = createTraitsSelector<'SITE'>(
	'SITE',
	({ getTraitByName }) => {
		return !!getTraitByName('jira_workmanagement_linked_trello_workspace')?.value;
	},
);
